import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../context/AuthContext';

export default function Permissions({ onCancel, user, fetchUsers }) {
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
  useEffect(() => {
    setSelectedRoles(user.permissions || []);
  }, [user]);

  const handleRoleToggle = (value) => {
    if (selectedRoles.includes(value)) {
      setSelectedRoles((prevRoles) => prevRoles.filter((role) => role !== value));
    } else {
      setSelectedRoles((prevRoles) => [...prevRoles, value]);
    }
  };

  const permissionsHaveChanged = () => {
    return JSON.stringify(selectedRoles) !== JSON.stringify(user.permissions);
  };
  
  const isSaveDisabled = !permissionsHaveChanged();
  
  const handleSave = () => {
    if (isSaveDisabled) {
      return;
    }
    setIsLoading(true);
    axiosInstance
      .post('/user/permissions', {userId: user._id, selectedRoles} )
      .then((response) => {
        setIsSuccess(true);
        setIsLoading(false);
        if (fetchUsers) {
          fetchUsers();
        }
        setTimeout(() => {
          setIsSuccess(false);
          onCancel();
        }, 1500);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error('Error saving permissions:', error);
      });
  };

  return (
    <div className="m-2">
      <div className="mt-4">
        <label className="block text-sm font-medium text-gray-700">Select Roles:</label>
        <div className="mt-1">
          <div className="mb-2">
            <label className="inline-flex items-center">
              <div
                className={`${
                  selectedRoles.includes('curator') ? 'bg-blue-500' : 'bg-gray-200'
                } relative inline-flex items-center h-6 rounded-full w-11`}
                onClick={() => handleRoleToggle('curator')}
              >
                <span
                  className={`${
                    selectedRoles.includes('curator') ? 'translate-x-6' : 'translate-x-1'
                  } inline-block w-4 h-4 transform bg-white rounded-full`}
                />
              </div>
              <span className="ml-2">Curator</span>
            </label>
          </div>
          <div>
            <label className="inline-flex items-center">
              <div
                className={`${
                  selectedRoles.includes('artist') ? 'bg-blue-500' : 'bg-gray-200'
                } relative inline-flex items-center h-6 rounded-full w-11`}
                onClick={() => handleRoleToggle('artist')}
              >
                <span
                  className={`${
                    selectedRoles.includes('artist') ? 'translate-x-6' : 'translate-x-1'
                  } inline-block w-4 h-4 transform bg-white rounded-full`}
                />
              </div>
              <span className="ml-2">Artist</span>
            </label>
          </div>
        </div>
      </div>
      <div className="mt-2">
      {isLoading ? (
          <p>Saving...</p> 
        ) : isSuccess ? (
          <p className="text-green-500">Permissions saved successfully!</p> 
        ) : (
          <button
            className={`px-2 py-2 mr-1 font-semibold text-white text-sm bg-blue-500 rounded ${
              isSaveDisabled ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            onClick={handleSave}
            disabled={isSaveDisabled}
          >
            Save
          </button>
        )}
        <button
          className="px-2 py-2 font-semibold text-white text-sm bg-red-500 rounded"
          onClick={() => onCancel()}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
